export default __webpack_public_path__ + "static/media/searchImg.a0828eda.svg";